
  import {Component, Vue} from 'vue-property-decorator';
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import ReportTable from "@/modules/Report/components/ReportTable.vue";
  import {ReportPrintActions} from "@/modules/Report/mixins/print-data.mixin";
  import {IApp} from "@/interfaces/app.interface";
  import _ from "lodash";
  import ParksTableTotal from "@/modules/Report/components/SpecialComponents/ParksTableTotal.vue";

  @Component({
    components: {
      ParksTableTotal,
      ReportTable,
    },
  })
  export default class ReportTableParks extends Vue {

    get tableList(): any[] { return this.$store.getters['report/sortedList'].array; }
    get dataProps() {
      return [
        { label: 'Корпорация',             prop: 'corpName',     propType: IApp.SortingPropType.String, actionClick: this.openCarsReport },
        { label: 'Машин',                  prop: 'cars',         propType: IApp.SortingPropType.Number, },
        { label: 'Гостей',                 prop: 'guests',       propType: IApp.SortingPropType.Number, },
        { label: 'В архиве',               prop: 'archive',      propType: IApp.SortingPropType.Number, },
        { label: 'Заездов',                prop: 'movs',         propType: IApp.SortingPropType.Number, },
        { label: 'Уникальных',             prop: 'uniqueMovs',   propType: IApp.SortingPropType.Number, },
        { label: 'Стоянка ср.время (ч.)',  prop: 'timeParkHour', propType: IApp.SortingPropType.Number, },
        { label: 'Аккаунтов',              prop: 'cntPers',      propType: IApp.SortingPropType.Number, },
        { label: 'Начислено',              prop: 'totalSum',     propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Оплачено',               prop: 'paySum',       propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Через Баланс',           prop: 'fromBalance',  propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Итого',                   prop: 'corpDolg',     propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Последний заезд',        prop: 'lastMov',      propType: IApp.SortingPropType.Date, dateFormat: 'DD.MM.YYYY', mobileHide: true, },
      ];
    }
    get printedOptions() {
      return {
        $options: this.$options,
        tableList: this.tableList,
        dataProps: this.dataProps,
      };
    }

    async reloadData() {
      await this.$store.dispatch('report/getReport', {
        reportName: this.$store.state.report.activeReport,
        filters: {...this.$store.state.report.filters},
      });
    }

    printTable() {
      ReportPrintActions.PrintTable(this.printedOptions);
    }

    prepareExcel() {
      return ReportPrintActions.PrepareExcel(this.printedOptions);
    }

    async openCarsReport(item) {
      // this.$store.dispatch('openPage', {
      //   routeName: IApp.ROUTE_NAME.PAGE_REPORT_CARS,
      //   query: {
      //     filters: {
      //       corpId: item.corpId,
      //     }
      //   }
      // });

      let detailFilters: IReport.IFilters = {
        ...this.$store.state.report.filters,
        corpId: item.corpId,
        str: '',
      };

      this.$store.commit('report/setProperty', { name: 'defaultFilters', value: _.cloneDeep(this.$store.state.report.filters) });
      this.$store.commit('report/setProperty', { name: 'filters', value: detailFilters });

      this.$store.commit('report/setProperty', { name: 'displayDetails', value: true });

      this.$store.commit('report/setProperty', { name: 'previousReport',value: {
          name: IReport.ReportName.Parks,
          list: this.$store.state.report.report,
        }
      });
      await this.$store.dispatch('report/getReport', { reportName: IReport.ReportName.Cars, filters: detailFilters, });
    }
  }
